import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getSalonFollowingCount = async (id: string) => {
  const { count, error } = await supabase
    .from('following_salons')
    .select('*', { count: 'exact', head: true })
    .eq('user_id', id);

  if (error) {
    throw new Error(error.message);
  }

  return count || 0;
};

export default function useSalonFollowingCount(id: string) {
  return useQuery({
    queryKey: ['salonFollowingCount', id],
    queryFn: () => getSalonFollowingCount(id),
    enabled: Boolean(id),
    staleTime: 60000,
  });
}
